<script setup lang="ts">
</script>
<template>
  <div class="space-y-2 prose dark:prose-invert">
    <p>BetPic is a Voxbet product, built using Voxbet's Speak Type Bet API Technology.</p>
    <p>If you are a Bookmaker, Affiliate, Influencer or other interested business then get in touch.</p>
    <p>
      Email: <a href="mailto:info@betpic.com" class="text-blue-600 dark:text-blue-400 underline">info@betpic.com</a><br>
      Website: <a href="https://voxbet.com" class="text-blue-600 dark:text-blue-400 underline">voxbet.com</a>
    </p>
  </div>
</template>